import { Activity } from '@/stakeholders/entities/activity'

export default [
  { value: Activity.Active, text: "aktiv" },
  { value: Activity.Passive, text: "passiv" },
]
